import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { LoginPage } from './pages/login-page/LoginPage';
import { LoginErrorPage } from './pages/login-error-page/LoginErrorPage';
import { LoginByVinPage } from './pages/login-by-vin-page/LoginByVinPage';
import { LoginByVinErrorPage } from './pages/login-by-vin-error-page/LoginByVinErrorPage';
import { VehicleDetailsPage } from './pages/vehicle-details-page/VehicleDetailsPage';
import { ServiceRequestPage } from './pages/service-request-page/ServiceRequestPage';
import { SelectDealerPage } from './pages/select-dealer-page/SelectDealerPage';
import { CustomerContactPage } from './pages/customer-contact-page/CustomerContactPage';
import { SelectServiceDatePage } from './pages/select-service-date-page/SelectServiceDatePage';
import { PriceEstimateWithServicePlanPage } from './pages/price-estimate-with-service-plan-page/PriceEstimateWithServicePlanPage';
import { PriceEstimateWithoutServicePlanPage } from './pages/price-estimate-without-service-plan-page/PriceEstimateWithoutServicePlanPage';
import { VerifyBookingDetailsPage } from './pages/verify-booking-details-page/VerifyBookingDetailsPage';
import { SendConfirmationMessagePage } from './pages/send-confirmation-message-page/SendConfirmationMessagePage';
import { BookingsPage } from './pages/bookings-page/BookingsPage';
import { ErrorPage } from './pages/error-page/ErrorPage';
import { PageRoutes } from './modules/navigation/PageRoutes';
import { HistoryServiceV2 } from '@feature-hub/history-service';
import { VwLayout } from './modules/layout/VwLayout';
import React from 'react';
import { PageScope } from './tracking/PageScope';
import { StepScopeProvider } from './modules/contexts/step-scope-context/StepScopeContextProvider';
import { Steps } from './modules/wizard/Steps';
import { BrandState, useBrand } from "./modules/contexts/brand-context/BrandProvider";

function Routes({ path }: { path: string }) {
  const createPagePath = (x: string) => `${path}/${x}`;

  return (
    <Switch>
      <Route path={createPagePath('login')}>
        <LoginPage />
      </Route>
      <Route path={createPagePath('login-error')}>
        <PageScope id="login-error-page">
          <LoginErrorPage />
        </PageScope>
      </Route>
      <Route path={createPagePath('login-by-vin')}>
        <PageScope id="login-by-vin-page">
          <LoginByVinPage />
        </PageScope>
      </Route>
      <Route path={createPagePath('login-by-vin-error')}>
        <PageScope id="login-by-vin-error-page">
          <LoginByVinErrorPage />
        </PageScope>
      </Route>
      <Route path={createPagePath('vehicle-details')}>
        <StepScopeProvider value={{ stepNumber: Steps.YourVehicle }}>
          <PageScope id="vehicle-details-page">
            <VehicleDetailsPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('service-request')}>
        <StepScopeProvider value={{ stepNumber: Steps.SelectService }}>
          <PageScope id="service-request-page">
            <ServiceRequestPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('select-dealer')}>
        <StepScopeProvider value={{ stepNumber: Steps.SelectDealer }}>
          <PageScope id="select-dealer-page">
            <SelectDealerPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('customer-contact')}>
        <StepScopeProvider value={{ stepNumber: Steps.ContactDetails}}>
          <PageScope id="customer-contact-page">
            <CustomerContactPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('select-service-date')}>
        <StepScopeProvider value={{ stepNumber: Steps.Appointment }}>
          <PageScope id="select-service-date-page">
            <SelectServiceDatePage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      {/*
      <Route path={createPagePath('select-collection-delivery-options')}>
        <StepScopeProvider value={{ stepNumber: Steps.CollectionAndDelivery }}>
          <PageScope id="select-collection-delivery-options-page">
            <SelectCollectionDeliveryPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      */}
      <Route path={createPagePath('price-estimate-with-service-plan')}>
        {/* TODO: uncommite if extimation pages be done */}
        {/* <StepScopeProvider value={{ stepNumber: Steps. }}> */}
          <PageScope id="price-estimate-with-service-plan-page">
            <PriceEstimateWithServicePlanPage />
          </PageScope>
        {/* </StepScopeProvider> */}
      </Route>
      <Route path={createPagePath('price-estimate-without-service-plan')}>
        <PageScope id="price-estimate-without-service-plan-page">
          <PriceEstimateWithoutServicePlanPage />
        </PageScope>
      </Route>
      <Route path={createPagePath('verify-booking-details')}>
        <StepScopeProvider value={{ stepNumber: Steps.ReviewAndSubmit }}>
          <PageScope id="verify-booking-details-page">
            <VerifyBookingDetailsPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('send-confirmation-message')}>
        <PageScope id="send-confirmation-message-page">
          <SendConfirmationMessagePage />
        </PageScope>
      </Route>
      <Route path={createPagePath('bookings')}>
        <StepScopeProvider value={{ stepNumber: Steps.Bookings }}>
          <PageScope id="bookings-page">
            <BookingsPage />
          </PageScope>
        </StepScopeProvider>
      </Route>
      <Route path={createPagePath('error')}>
        <PageScope id="error-page">
          <ErrorPage />
        </PageScope>
      </Route>
      <Route path={createPagePath('')}>
        <Redirect push to={createPagePath(PageRoutes.Login)} />
      </Route>
    </Switch>
  );
}

export interface AppRouterProps {
  historyService: HistoryServiceV2;
}

export function AppRouter({ historyService }: AppRouterProps) {
  const { brand } = useBrand();
  const path = `/${brand === BrandState.Audi ? 'audi' : 'vw'}`;

  return (
    <Router history={historyService.history}>
      <Switch>
        <Route path={path}>
          <VwLayout>
            <Routes path={path}></Routes>
          </VwLayout>
        </Route>
        <Route path={'*'}>
          <Redirect to={path} />
        </Route>
      </Switch>
    </Router>
  );
}
